import TableBlock from '../components/tableBlock'

class TableBlocks {
	private components: TableBlock[] = []

	init(container: Document | HTMLElement = document) {
		container.querySelectorAll<HTMLElement>('.hg-table-block').forEach((el) => {
			const c = new TableBlock(el)
			c.init()
			this.components.push(c)
		})
	}

	update(container: Document | HTMLElement = document) {
		this.cleanup()
		this.init(container)
	}

	cleanup() {
		this.components.forEach((c) => c.cleanup())
		this.components = []
	}
}

export default new TableBlocks()
